import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { injectGlobal } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { ChartTool } from 'actions';
import HoldingsConcentration from '../index';

// eslint-disable-next-line no-unused-vars
const InjectPrintReset = injectGlobal`
  @media print {
    html,
    body {
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
    }

    #root {
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
    }
  }
`;

@withRouter
class HoldingsConcentrationToolPDF extends Component {
  constructor(props) {
    super(props);
    const mql = window.matchMedia('print');

    this.state = {
      isPrintReady: false,
      mql,
    };
  }

  componentWillMount = () => {
    window.scrollTo(0, 0);

    // resize charts on print
    this.state.mql.addListener(this.printListener);

    return false;
  };

  componentDidMount = () => {
    this.logoTimeoutDone = false;
    this.timeoutId = window.setTimeout(() => {
      this.logoTimeoutDone = true;
      this.setState({ isPrintReady: true });
    }, 1000);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.isPrintReady !== prevState.isPrintReady) {
      const printFileName = 'holdings-concentration';
      const originalTitle = document.title;

      document.title = printFileName;
      window.print();
      document.title = originalTitle;
    }
  };

  componentWillUnmount = () => {
    window.clearTimeout(this.timeoutId);
    this.state.mql.removeListener(this.printListener);
  };

  printListener = (e) => {
    const { history } = this.props;
    // resize charts on print
    if (e.matches) {
      Object.keys(window.Chart.instances).forEach((key) => {
        window.Chart.instances[key].resize();
      });
    } else {
      history.goBack();
    }
  };

  updateStartEndDate = (startDate, endDate) => {
    const { dispatch } = this.props;

    dispatch(
      ChartTool.updateInputs({ periodStart: startDate, periodEnd: endDate })
    );
  };

  render() {
    return (
      <PDF>
        <HoldingsConcentration isPrinting />
      </PDF>
    );
  }
}

HoldingsConcentrationToolPDF.propTypes = {
  history: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
};

HoldingsConcentrationToolPDF.defaultProps = {
  history: {},
};

export default connect((state) => ({
  securityData: state.FundComparison.securityData,
  securityTickerList: Object.keys(state.FundComparison.securityData || {}),
}))(HoldingsConcentrationToolPDF);

const PDF = styled.div`
  position: relative;
  background: white;
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
  width: 1160px;
  margin: -45px auto 5px auto;
  @media only print {
    print-color-adjust: exact;
    @page {
      size: auto;
      margin: 0.5cm;
    }
  }
`;
